import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";

import Container from "../../../components/Layout/Container";
import InfoZonesTab from "./components/InfoZonesTab";
import BlocksTab from "./components/BlocksTab";

const BREADCRUMBS = [
  { label: "Marketing", value: "/marketing" },
  { label: "Info Zone Manager", value: "/marketing/info_zone_manager" },
];

const queryClient = new QueryClient();

function InfoZoneManagerPage({ match }) {
  const [tabId, setTabId] = React.useState("info_zones");

  return (
    <Container
      location={{
        locationName: "Info Zone Manager",
        locationUrl: match?.url,
      }}
      breadcrumbs={BREADCRUMBS}
    >
      {tabId === "blocks" ? (
        <BlocksTab tabId={tabId} setTabId={setTabId} />
      ) : (
        <InfoZonesTab tabId={tabId} setTabId={setTabId} />
      )}
    </Container>
  );
}

function InfoZoneManagerPageWithProvider(props) {
  return (
    <QueryClientProvider client={queryClient}>
      <InfoZoneManagerPage {...props} />
    </QueryClientProvider>
  );
}

export default InfoZoneManagerPageWithProvider;
